<template>
  <form @submit.prevent="submitForm">
    <div>
      <p class="mb-4">Are you sure you wish to delete this task?</p>

      <div class="flex space-x-2">
        <BaseButton primary small :disabled="pending"> Delete </BaseButton>
        <BaseButton
          type="button"
          primary
          small
          outline
          :disabled="pending"
          @click="$emit('cancel')"
        >
          Cancel
        </BaseButton>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  inject: ['refreshTasks'],
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      pending: false,
    };
  },

  methods: {
    async submitForm() {
      this.pending = true;

      try {
        await this.$store.dispatch('ui/tasks/destroy', {
          taskUuid: this.task.uuid,
        });

        if (typeof this.refreshTasks === 'function') {
          this.refreshTasks();
        }
      } catch (error) {
        //
      }
      this.pending = false;
    },
  },
};
</script>
